var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 25.6668H17.5C23.3333 25.6668 25.6667 23.3335 25.6667 17.5002V10.5002C25.6667 4.66683 23.3333 2.3335 17.5 2.3335H10.5C4.66668 2.3335 2.33334 4.66683 2.33334 10.5002V17.5002C2.33334 23.3335 4.66668 25.6668 10.5 25.6668Z",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0833 21.5832C19.3667 21.5832 20.4167 20.5332 20.4167 19.2498V8.74984C20.4167 7.4665 19.3667 6.4165 18.0833 6.4165C16.8 6.4165 15.75 7.4665 15.75 8.74984V19.2498C15.75 20.5332 16.7883 21.5832 18.0833 21.5832Z",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91668 21.5835C11.2 21.5835 12.25 20.5335 12.25 19.2502V15.1668C12.25 13.8835 11.2 12.8335 9.91668 12.8335C8.63334 12.8335 7.58334 13.8835 7.58334 15.1668V19.2502C7.58334 20.5335 8.62168 21.5835 9.91668 21.5835Z",
    stroke: "#2C3941",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c29336f9b8d4a214b91fc1067a61cbcf.svg";
export { ForwardRef as ReactComponent };